/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetTradeScheduleRequestAttachment$Pdf$Params {

/**
 * Trade request id.
 */
  id: number;
}

export function getTradeScheduleRequestAttachment$Pdf(http: HttpClient, rootUrl: string, params: GetTradeScheduleRequestAttachment$Pdf$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, getTradeScheduleRequestAttachment$Pdf.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

getTradeScheduleRequestAttachment$Pdf.PATH = '/api/scheduler/trade-schedule-requests/{id}/attachment';
